import React, { FC, Fragment, memo, useCallback } from 'react'
import { IFacet } from '@ucheba/utils/types/search'
import { IFacetItemWrapperProps } from '../types'
import { Spacing } from '../../Spacing/desktop'
import { Dropdown } from '../../Dropdown/desktop'
import FacetItem from './FacetItem'
import { useFacetItemWrapperCore } from '../bll'

/** Обертка фасета */
const FacetItemWrapper: FC<IFacetItemWrapperProps> = (props) => {
  const { facet, controlName, isRadio, isForcedArray, fontWeight } = props

  const { onDropdownOpen, getOpenStatus } = useFacetItemWrapperCore({
    controlName,
    isRadio,
    isForcedArray,
  })

  const getFacetItems = useCallback(
    (childrenItems: IFacet[]): JSX.Element[] => {
      return childrenItems.map((childFacet, index) => (
        <Fragment key={childFacet.value}>
          {!index && <Spacing spacing='large' />}

          <FacetItem
            {...childFacet}
            isRadio={isRadio}
            controlName={controlName}
            fontWeight={fontWeight}
          />
        </Fragment>
      ))
    },
    [controlName, isRadio, fontWeight]
  )

  return (
    <>
      {facet.items && facet.items?.length ? (
        <>
          <Dropdown
            preventOutsideClose
            fontWeight='semibold'
            spacing='null'
            block
            open={getOpenStatus(facet.items)}
            position='static'
            width='100%'
            onOpen={onDropdownOpen}
            menu={getFacetItems(facet.items)}
            title={facet.name}
          />

          <Spacing spacing='large' />
        </>
      ) : (
        <FacetItem
          {...facet}
          controlName={controlName}
          isRadio={isRadio}
          fontWeight={fontWeight}
        />
      )}
    </>
  )
}

export default memo(FacetItemWrapper)
